import React from 'react'

import i18n from 'i18next'
import numeral from 'numeral'

import {
  Progress,
  Icon,
  SuccessFilled,
  InfoOutlined,
  Tooltip,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number, string } from 'prop-types'

import { getCartProgress } from 'Utils/getCartProgress'

function ProgressIcon() {
  return <SuccessFilled width="24" height="24" />
}

function InfoIcon() {
  return <InfoOutlined width="24" height="24" />
}

function SaleProgress({ saleThreshold, totalPrice, locale = 'en' }) {
  const currentProgress = getCartProgress(totalPrice, saleThreshold)
  const progress = Math.floor(currentProgress)
  const isUnderThreshold = progress !== 100
  const leftToUnlock = numeral(saleThreshold - totalPrice).format('$0.00')

  const tooltipContent = i18n.t('navigation.cart_widget.sale_tooltip', {
    ns: 'rails',
    lng: locale,
    threshold: saleThreshold,
  })
  const leftToUnlockDiscounts = i18n.t('navigation.cart_widget.left_to_unlock_discounts', {
    ns: 'rails',
    lng: locale,
    leftToUnlock,
  })

  const progressCount = <p className="cgt-legacy-text-caption cgt-mb-0 cgt-legacy-color-brand-primary-120">{leftToUnlockDiscounts}</p>

  return (
    <div className="sale-progress">
      <Tooltip
        id="sale-tooltip"
        randomizeID
        html
        place="top"
        content={tooltipContent}
        className="product-list__price-description"
        containerClass="cgt-mb-4"
      >
        <Icon notSpaced size="tiny" color="dark" svgComponent={InfoIcon} />
      </Tooltip>

      <div className={classnames('sale-progress__container', progress === 100 && 'sale-progress__container--no-space')}>
        <div className="sale-progress__wrapper">
          <Progress
            progress={progress}
            height={22}
            useGradient
            isSpaced={false}
            currentCount={progress === 100 ? '' : progressCount}
          />
        </div>

        <div className="sale-progress__total-count cgt-legacy-color-brand-primary-120">
          <Icon
            notSpaced
            size="tiny"
            color="primary"
            disabled={isUnderThreshold}
            svgComponent={ProgressIcon}
            className={classnames(
              'cart-progress__icon cart-progress__icon--big',
              isUnderThreshold && 'cart-progress__icon--disabled'
            )}
          />
          ${saleThreshold}
        </div>
      </div>
    </div>
  )
}

SaleProgress.propTypes = {
  saleThreshold: number.isRequired,
  totalPrice: number.isRequired,
  locale: string,
}

export default SaleProgress
